import CacheManager from "WebSocket/CacheManager/CacheManager";

export class ClientBase {

    protected transformOptions(options: RequestInit) {
        if (CacheManager.Store) {
            const jwt = CacheManager.Store.getState()!.jwt;
            if (jwt) {

                if (options.headers) {
                    options.headers = {
                        ...options.headers,
                        "Authorization": `Bearer ${jwt}`
                    }
                } else {
                    options.headers = {
                        "Accept": "application/json",
                        "Authorization": `Bearer ${jwt}`,
                        "Content-Type": "application/json"
                    }
                }
            }
        } 
        return Promise.resolve(options);
    }

    protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
        // TODO: Return own result or throw exception to change default processing behavior, 
        // or call processor function to run the default processing logic

        console.log("Service call: " + url);
        return processor(response);
    }
}